import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import zhCN from '@/locales/zh-CN';
import './main.less';

// Leaflet CSS
import 'leaflet/dist/leaflet.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <IntlProvider locale="zh-CN" defaultLocale="zh-CN" messages={zhCN}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </IntlProvider>
    </StrictMode>
);
